import PageLayout from 'pages/CourseSetup/PageLayout';
import PageProvider from 'pages/CourseSetup/PageProvider';

const CourseSetup = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout />
        </PageProvider>
    );
};

export default CourseSetup;

